import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentIcon } from '@treams/treams-icons';
import { Popover, Sidebar } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import DashboardDownloadScoresOptions from './DashboardDownloadScoresOptions';

export default function DashboardDownloadScores(props: { filters: graphql.AnalyticsFilters }) {
	const { t } = useTranslation();

	const [popover, setPopover] = useState(false);

	return (
		<Popover.Target
			visible={popover}
			contents={
				<DashboardDownloadScoresOptions
					startDate={new Date(props.filters.startDate)}
					endDate={new Date(props.filters.endDate)}
					onFinish={() => setPopover(false)}
				/>
			}
			onDismiss={() => setPopover(false)}
		>
			<Sidebar.Item
				icon={<DocumentIcon />}
				title={t('dashboard.sidebar.downloads.scores.title')}
				small
				onClick={() => setPopover(true)}
			/>
		</Popover.Target>
	);
}
